import { apiFetch } from './api-fetch.js'
import { assert } from '../shared/assert.js'
import { setTokenMetadata } from '../session/session.js'

/** @param {UserSignup} user */
export async function signupUser(user) {
  return apiFetch(`/v1/users/signup`, 'POST', user).then((r) => r.json())
}

/**
 * @description for getting user overview information for less secure operations
 * such as when one user needs to find another user from a list
 * @returns {Promise<PublicUser[]>}
 * */
export async function getAllUsers() {
  // TODO: This is the actual endpoint, wire it up when it's ready
  return apiFetch(`/v1/users`, 'GET').then((r) => r.json())
}

/**
 * @param {string} userId
 * @returns
 */
export async function getUserById(userId) {
  return apiFetch(`/v1/user?id=${userId}`, 'GET').then((r) => r.json())
}

/**
 * V2 Login using JWT with HttpOnly cookies
 * @param {{email: string, password: string, deviceFingerprint: string}} credentials
 * @returns {Promise<Response>} - Returns empty 200 OK on success
 */
export async function loginUserV2({ email, password, deviceFingerprint }) {
  assert(!!email, 'Email is required for login', { email, password, deviceFingerprint })
  assert(!!password, 'Password is required for login', { email, password, deviceFingerprint })
  assert(!!deviceFingerprint, 'Device fingerprint is required for login', { email, password, deviceFingerprint })

  return await apiFetch(`/v2/authentication/token`, 'POST', {
    email,
    password,
    deviceFingerprint,
  })
}

/**
 * V2 Refresh token using JWT cookies
 * @returns {Promise<JWTRefreshResponse|Response>}
 */
export async function refreshTokenV2() {
  const response = await apiFetch(`/v2/authentication/refresh`, 'POST')

  if (response.ok) {
    const refreshData = await response.json()
    // Store the new expiration times
    // Convert expiry formats to Unix timestamps
    const accessExpiry = new Date(refreshData.expiry).getTime()
    const refreshExpiry = parseRefreshExpiry(refreshData.refresh)

    setTokenMetadata({
      accessExpiry,
      refreshExpiry,
      lastRefresh: Date.now(),
      isAuthenticated: true,
    })

    return refreshData
  }

  return response
}

/**
 * Get current user using JWT cookie authentication
 * @returns {Promise<User>}
 */
export async function getCurrentUser() {
  return apiFetch(`/v1/users/me`, 'GET').then((r) => r.json())
}

/**
 * Parse cookie date format to Unix timestamp
 * @param {string} cookieDate - e.g., "Mon, 01 Jan 2025 12:00:00 GMT"
 * @returns {number} Unix timestamp
 */
function parseRefreshExpiry(cookieDate) {
  return new Date(cookieDate).getTime()
}
